import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useStore } from '../hooks/useStore';
import { fetchVendors } from '../lib/api';
import { safeArray } from '../lib/safe';

export const Route = createFileRoute('/vendors')({
  component: VendorsPage,
});

function VendorsPage() {
  const { activeStore } = useStore();

  const { data, isLoading } = useQuery({
    queryKey: ['vendors', activeStore.shop],
    queryFn: () => fetchVendors(activeStore.shop),
  });

  const vendors = safeArray(data?.vendors);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[var(--ccb-text)]">Vendors</h2>

      <div className="bg-white rounded-xl border border-[var(--ccb-border)] overflow-hidden">
        {isLoading ? (
          <div className="p-12 text-center text-sm text-[var(--ccb-text-secondary)]">Loading vendors...</div>
        ) : vendors.length === 0 ? (
          <div className="p-12 text-center text-sm text-[var(--ccb-text-secondary)]">No vendor data available</div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[var(--ccb-border)]">
                <th className="text-left px-4 py-3 text-xs font-semibold text-[var(--ccb-text-secondary)] uppercase tracking-wide">Vendor</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-[var(--ccb-text-secondary)] uppercase tracking-wide">Products</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-[var(--ccb-text-secondary)] uppercase tracking-wide">Optimized</th>
                <th className="text-left px-4 py-3 text-xs font-semibold text-[var(--ccb-text-secondary)] uppercase tracking-wide">Coverage</th>
              </tr>
            </thead>
            <tbody>
              {vendors.map((v) => {
                const pct = v.count > 0 ? Math.round(((v.optimized ?? v.count) / v.count) * 100) : 0;
                return (
                  <tr key={v.vendor} className="border-b border-[var(--ccb-border)] last:border-0 hover:bg-slate-50/50">
                    <td className="px-4 py-3 font-medium text-[var(--ccb-text)]">{v.vendor}</td>
                    <td className="px-4 py-3 text-[var(--ccb-text-secondary)]">{v.count}</td>
                    <td className="px-4 py-3 text-[var(--ccb-text-secondary)]">{v.optimized}</td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-24 h-2 bg-slate-100 rounded-full overflow-hidden">
                          <div
                            className="h-full rounded-full transition-all"
                            style={{ width: `${pct}%`, backgroundColor: pct === 100 ? 'var(--ccb-success)' : 'var(--ccb-primary)' }}
                          />
                        </div>
                        <span className="text-xs text-[var(--ccb-text-secondary)]">{pct}%</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
